require("core-js/modules/esnext.global-this.js");

!function (e, r) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = r(require("react"), require("prop-types"), require("@leafygreen-ui/emotion")) : "function" == typeof define && define.amd ? define(["react", "prop-types", "@leafygreen-ui/emotion"], r) : ((e = "undefined" != typeof globalThis ? globalThis : e || self).CheckmarkWithCircle = e.CheckmarkWithCircle || {}, e.CheckmarkWithCircle.js = r(e.React, e.PropTypes, e["@leafygreen-ui/emotion"]));
}(this, function (e, r, t) {
  "use strict";

  function l(e) {
    return e && "object" == typeof e && "default" in e ? e : {
      default: e
    };
  }

  function a(e) {
    if (e && e.__esModule) return e;
    var r = Object.create(null);
    return e && Object.keys(e).forEach(function (t) {
      if ("default" !== t) {
        var l = Object.getOwnPropertyDescriptor(e, t);
        Object.defineProperty(r, t, l.get ? l : {
          enumerable: !0,
          get: function get() {
            return e[t];
          }
        });
      }
    }), r.default = e, Object.freeze(r);
  }

  var i = a(e),
      n = l(r);

  function o(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[r] = t, e;
  }

  function c() {
    return c = Object.assign || function (e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = arguments[r];

        for (var l in t) {
          Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
        }
      }

      return e;
    }, c.apply(this, arguments);
  }

  function u(e, r) {
    if (null == e) return {};

    var t,
        l,
        a = function (e, r) {
      if (null == e) return {};
      var t,
          l,
          a = {},
          i = Object.keys(e);

      for (l = 0; l < i.length; l++) {
        t = i[l], r.indexOf(t) >= 0 || (a[t] = e[t]);
      }

      return a;
    }(e, r);

    if (Object.getOwnPropertySymbols) {
      var i = Object.getOwnPropertySymbols(e);

      for (l = 0; l < i.length; l++) {
        t = i[l], r.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(e, t) && (a[t] = e[t]);
      }
    }

    return a;
  }

  function f(e, r) {
    return r || (r = e.slice(0)), Object.freeze(Object.defineProperties(e, {
      raw: {
        value: Object.freeze(r)
      }
    }));
  }

  var s,
      b,
      p = {
    small: 14,
    default: 16,
    large: 20,
    xlarge: 24
  };

  var d = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"],
      y = function y(e) {
    var r,
        l = e.className,
        a = e.size,
        n = void 0 === a ? 16 : a,
        y = e.title,
        m = e["aria-label"],
        h = e["aria-labelledby"],
        g = e.fill,
        O = e.role,
        v = void 0 === O ? "img" : O,
        C = u(e, d),
        j = t.css(s || (s = f(["\n    color: ", ";\n  "])), g),
        k = t.css(b || (b = f(["\n    flex-shrink: 0;\n  "]))),
        w = function (e, r, t) {
      var l,
          a,
          i = t["aria-label"],
          n = t["aria-labelledby"],
          c = t.title;

      switch (e) {
        case "img":
          return i || n || c ? (o(l = {}, "aria-labelledby", n), o(l, "aria-label", i), o(l, "title", c), l) : {
            "aria-label": (a = r, "".concat(a.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon"))
          };

        case "presentation":
          return {
            "aria-hidden": !0,
            alt: ""
          };
      }
    }(v, "CheckmarkWithCircle", (o(r = {
      title: y
    }, "aria-label", m), o(r, "aria-labelledby", h), r));

    return i.createElement("svg", c({
      className: t.cx(o({}, j, null != g), k, l),
      height: "number" == typeof n ? n : p[n],
      width: "number" == typeof n ? n : p[n],
      role: v
    }, w, C, {
      viewBox: "0 0 16 16"
    }), i.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM10.4485 4.89583C10.8275 4.45816 11.4983 4.43411 11.9077 4.84352C12.2777 5.21345 12.2989 5.80633 11.9564 6.2018L7.38365 11.4818C7.31367 11.5739 7.22644 11.6552 7.12309 11.7208C6.65669 12.0166 6.03882 11.8783 5.74302 11.4119L3.9245 8.54448C3.6287 8.07809 3.767 7.46021 4.2334 7.16442C4.69979 6.86863 5.31767 7.00693 5.61346 7.47332L6.71374 9.20819L10.4485 4.89583Z",
      fill: "currentColor"
    }));
  };

  return y.displayName = "CheckmarkWithCircle", y.isGlyph = !0, y.propTypes = {
    fill: n.default.string,
    size: n.default.oneOfType([n.default.number, n.default.string]),
    className: n.default.string
  }, y;
});